import { useGetBankAccountsForCompanyQuery } from '../../BankAccounts/Service/extendedBankAccountsApi';
import {
  mapBankAccountToBankDocumentLookup,
  type BankDocumentBankAccountLookup,
} from './bankAccountsLookupMapper';

export const useGetBankDocumentBankAccountsLookupQuery = (
  companyId: number | undefined
): {
  accounts: BankDocumentBankAccountLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetBankAccountsForCompanyQuery(companyId ?? 0, {
    skip: !companyId,
  });

  const accounts: BankDocumentBankAccountLookup[] = (data ?? [])
    .map(mapBankAccountToBankDocumentLookup)
    .filter((item): item is BankDocumentBankAccountLookup => item !== undefined);

  return { accounts, isLoading };
};
